import axios from '@/axios.js'
import Vue from 'vue'

export default {
  fetchOrders ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/orders/all')
        .then((response) => {
          commit('SET_ORDERS', response.data.data.orders)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser (context, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/order-management/orders/${orderId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/order-management/orders/${orderId}`)
        .then((response) => {
          commit('REMOVE_RECORD', orderId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateOrder ({ dispatch }, obj) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`/orders/update/${obj.id}`, obj)
        .then((response) => {
          //commit('UPDATE_PRODUCT', response.data.data.products)
          dispatch('fetchOrders')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
